import React, { useMemo, useState } from "react";
import { DEFAULT_PIC } from "./constants";
import { messagePreview } from "./chatUtils";

// =====================================================
// FORWARD MODAL
// Pick one or more conversations to forward the selected message(s) to.
// Content + metadata (text or file) are copied by the container; this modal
// only handles selection. Supports search and multi-select, mirroring the
// familiar messaging-app flow.
// =====================================================

function ForwardModal({ users, messages, onClose, onForward, sending }) {
  const [selected, setSelected] = useState(() => new Set());
  const [search, setSearch] = useState("");

  const filtered = useMemo(
    () =>
      users.filter((u) =>
        u.name.toLowerCase().includes(search.toLowerCase())
      ),
    [users, search]
  );

  const toggle = (id) => {
    setSelected((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const count = messages.length;
  const summary =
    count === 1 ? messagePreview(messages[0]) : `${count} messages`;

  return (
    <div className="chat-confirm-overlay" onClick={onClose}>
      <div
        className="forward-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="forward-head">
          <h3>Forward to…</h3>
          <button className="forward-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="forward-summary" title={summary}>
          ↪ {summary}
        </div>

        <input
          className="chat-search forward-search"
          placeholder="Search chats..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div className="forward-list">
          {filtered.length === 0 && (
            <p className="loading-text">No chats found</p>
          )}
          {filtered.map((u) => {
            const disabled = u.canChat === false;
            const isSel = selected.has(u._id);
            return (
              <div
                key={u._id}
                className={`forward-item ${isSel ? "selected" : ""} ${
                  disabled ? "disabled" : ""
                }`}
                onClick={() => !disabled && toggle(u._id)}
              >
                <img src={u.profilePic || DEFAULT_PIC} alt="" />
                <span className="forward-name">{u.name}</span>
                {disabled ? (
                  <span className="forward-disabled-tag">unavailable</span>
                ) : (
                  <span className={`forward-check ${isSel ? "on" : ""}`}>
                    {isSel ? "✓" : ""}
                  </span>
                )}
              </div>
            );
          })}
        </div>

        <div className="forward-actions">
          <button className="chat-confirm-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="chat-confirm-yes forward-send"
            disabled={selected.size === 0 || sending}
            onClick={() => onForward([...selected])}
          >
            {sending ? "Sending…" : `Send${selected.size ? ` (${selected.size})` : ""}`}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForwardModal;
